import React from 'react'

const YoungAdult = () => {
  return (
    <div>YoungAdult</div>
  )
}

export default YoungAdult